import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ResidentItemDto } from '@artemis-software/wr-api';

export interface ResidentDialogResult {
  customerNumber: string;
  startDate: string;
  endDate: string | null;
}

@Component({
  standalone: false,
  selector: 'wr-resident-dialog',
  templateUrl: './resident-dialog.component.html',
  styleUrls: ['./resident-dialog.component.scss'],
})
export class ResidentDialogComponent implements OnInit {
  @Input() existingResident: ResidentItemDto | null = null;
  @Input() otherResidents: ResidentItemDto[] = [];

  customerNumber = '';
  startDate: Date | undefined = undefined;
  endDate: Date | undefined = undefined;
  error: string | null = null;

  get isEdit(): boolean {
    return this.existingResident !== null;
  }

  constructor(private readonly dialogRef: NbDialogRef<ResidentDialogComponent>) {}

  ngOnInit(): void {
    if (this.existingResident) {
      this.customerNumber = this.existingResident.customerNumber;
      this.startDate = this.parseDate(this.existingResident.startDate);
      this.endDate = this.existingResident.endDate ? this.parseDate(this.existingResident.endDate) : undefined;
    }
  }

  submit(): void {
    if (!this.customerNumber.trim()) {
      this.error = 'Bitte geben Sie eine Kundennummer ein.';
      return;
    }
    if (!this.startDate) {
      this.error = 'Bitte wählen Sie ein Einzugsdatum.';
      return;
    }
    if (this.endDate && this.endDate < this.startDate) {
      this.error = 'Das Auszugsdatum darf nicht vor dem Einzugsdatum liegen.';
      return;
    }
    const startStr = this.toIsoDate(this.startDate);
    const endStr = this.endDate ? this.toIsoDate(this.endDate) : null;
    if (this.hasDateOverlap(startStr, endStr)) {
      this.error = 'Der Zeitraum überschneidet sich mit einem anderen Bewohner.';
      return;
    }
    this.dialogRef.close({
      customerNumber: this.customerNumber.trim(),
      startDate: startStr,
      endDate: endStr,
    } as ResidentDialogResult);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  private hasDateOverlap(start: string, end: string | null): boolean {
    const newEnd = end || '9999-12-31';
    for (const r of this.otherResidents) {
      const rEnd = r.endDate || '9999-12-31';
      if (start <= rEnd && r.startDate <= newEnd) {
        return true;
      }
    }
    return false;
  }

  private parseDate(dateStr: string): Date {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  private toIsoDate(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
